import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainGatesComponent } from './main-gates/main-gates.component';
import { AddGateComponent } from './add-gate/add-gate.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import { AddVillageConfigComponent } from './add-village-config/add-village-config.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { AddUserConfigComponent } from './add-user-config/add-user-config.component';
import { AddQrConfigComponent } from './add-qr-config/add-qr-config.component';


@NgModule({
  declarations: [MainGatesComponent, AddGateComponent, AddVillageConfigComponent, AddUserConfigComponent, AddQrConfigComponent],
  imports: [CommonModule, FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
     MatTabsModule, MatDialogModule]
})
export class GatesModule {}
